import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Container, Form, Segment } from 'semantic-ui-react';

import { formatDate } from '_utils';
import { licensePoolPropType, licensePoolSublicenseProps } from '_utils/licensePools';

import AddLicensePoolSublicenseForm from '_forms/institutionLicensePoolsAddSublicense';
import { SUBLICENSE_DISPLAY_NAMES } from '../../../../server/constants';
import useCanAdminLicenses from '../../../hooks/useCanAdminLicenses';

const LicensePoolSublicense = ({
  onRemove,
  sublicense
}) => {

  const canAdmin = useCanAdminLicenses();

  return (
    <Segment>
      <Form as={ Container } size="tiny">
        <Form.Group>
          <Form.Input width={ 8 } label='Name' name='name' value={ SUBLICENSE_DISPLAY_NAMES[sublicense.name] } readOnly />
          <Form.Input width={ 8 } label='Created On' name='created_on' value={ formatDate(sublicense.created_on) } readOnly />
        </Form.Group>
        {
          canAdmin ? (
            <Button
              negative
              content="Remove"
              size="mini"
              onClick={ () => onRemove(sublicense) }
            />
          ) : null
        }
      </Form>
    </Segment>
  );
}

LicensePoolSublicense.propTypes = {
  onRemove: PropTypes.func.isRequired,
  sublicense: PropTypes.shape(licensePoolSublicenseProps).isRequired
};

const LicensePoolSublicenses = ({ licensePool, onAddSublicense, onRemoveSublicense }) => {

  const canAdmin = useCanAdminLicenses();
  const [showAddSublicense, setShowAddSublicense] = useState(false);
  const onSubmitAddSubLicense = (name) => {
    onAddSublicense(name);
    setShowAddSublicense(false);
  }

  return (
    <Fragment>
      {
        canAdmin ? (
          <Button onClick={ () => setShowAddSublicense(true) } disabled={ showAddSublicense } size="small">
            Add
          </Button>
        ) : null
      }
      <Segment.Group>
        {
          !showAddSublicense && (
            licensePool.sublicenses.map(sublic => (
              <LicensePoolSublicense key={ sublic._id } sublicense={ sublic } onRemove={ onRemoveSublicense } />
            ))
          )
        }
        {
          showAddSublicense && (
            <Segment>
              <AddLicensePoolSublicenseForm licensePool={ licensePool } onCancel={ () => setShowAddSublicense(false) } onSubmit={ onSubmitAddSubLicense } />
            </Segment>
          )
        }
      </Segment.Group>
    </Fragment>
  )
};

LicensePoolSublicenses.propTypes = {
  licensePool: licensePoolPropType.isRequired,
  onAddSublicense: PropTypes.func.isRequired,
  onRemoveSublicense: PropTypes.func.isRequired
};

export default LicensePoolSublicenses;



// WEBPACK FOOTER //
// ./webAdmin/components/institutions/institution/licensePoolSublicenses.js